import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { useRuntime } from './runtime-provider';

/** TanStack Query with the defaults of docs/plan/12-frontend.md section 3. */
export function QueryProvider({ children }: { children?: ReactNode }) {
  const { queryClient } = useRuntime();
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
